import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import CardContent from '../../../components/Card/CardContent';
import CardMain from '../../../components/Card/CardMain';
import Container from '../../../components/Container';
import Heading from '../../../components/Heading';

const ConfirmationShow: FC = () => {
  return (
    <Container>
      <CardMain>
        <CardContent>
          <Heading>Deze link is niet (meer) geldig</Heading>
          <p>
            <Link to="/u/session/new">Probeer in te loggen</Link>
          </p>
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default ConfirmationShow;
